import { Link, useNavigate } from "react-router-dom";
import LayoutMain from "../../shared/layouts/LayoutMain/LayoutMain";
import { BCButton, TypeBrief } from "../../shared/styled/global.styled";

const Home = () => {

  const navigate = useNavigate();


  return (
    <LayoutMain idPage="Home">
      <div className="title-options bc-margin-top-3 bc-card-rounded">
        <div className="bc-row">
          <div className="bc-col-6">
            <h2>Bienvenidos a EDC Brief</h2>
          </div>
        </div>
        <h4>
          Sistema de recoleccion de datos de brief
        </h4>
        <p>
          <strong>Brief</strong> Busca generar interaccion entre agencias y media teams
        </p>
      </div>
      <div style={{margin: 10, zIndex: 2}}>
        <h5>¿Que tipo de brief vas a crear?</h5>
      </div>
      <TypeBrief>
        <Link to="/brief/crear/campaign" className="bc-card">
          Campaña
        </Link>
        <Link to="/brief/crear/iniciative" className="bc-card">
        Iniciativa 
        </Link>
        <Link to="/brief/crear/tactic" className="bc-card">
            Tactiva
        </Link>
      </TypeBrief>
    </LayoutMain>
  );
};

export default Home;
